import { createReducer } from 'typesafe-actions'
import { IUserBankAccount } from '@sparling/financial-common'
import { omit } from 'lodash'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import {
  getUserBankAccountsRequest,
  getUserBankAccountsSuccess,
  getUserBankAccountsFailure,
  updateUserBankAccountStatusSuccess,
} from '../actions'

export type UserBankAccountsState = {
  idSf: string | null
  loading: LoadingStateEnum
  data: {
    items: IUserBankAccount[]
    meta: {
      itemCount: number
      itemsPerPage: number
      totalItems: number
      totalPages: number
      currentPage: number
    }
  }
  error: Error | null
}

export const initialState = {
  idSf: null,
  loading: LoadingStateEnum.IDLE,
  data: {
    items: [],
    meta: {
      itemCount: 0,
      totalItems: 0,
      itemsPerPage: 0,
      totalPages: 0,
      currentPage: 0,
    },
  },
  error: null,
}

export const userBankAccounts = createReducer<UserBankAccountsState, ActionTypes>(initialState)
  .handleAction(getUserBankAccountsRequest, (state, { payload }) => ({
    ...state,
    filters: {
      ...payload,
      page: Object.keys(omit(payload, 'page')).length > 0 ? 1 : payload.page,
    },
    loading: LoadingStateEnum.LOADING,
  }))
  .handleAction(getUserBankAccountsSuccess, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.SUCCESS,
    data: payload.data,
  }))
  .handleAction(getUserBankAccountsFailure, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.ERROR,
    error: payload,
  }))
  .handleAction(updateUserBankAccountStatusSuccess, (state, action) => {
    if (!state.data.items || !action.payload.data) return state

    const updatedBankAccount = action.payload.data
    const updatedItems = state.data.items.map((item) =>
      item.id === updatedBankAccount.id ? { ...item, ...updatedBankAccount } : item,
    )

    return {
      ...state,
      data: {
        ...state.data,
        items: updatedItems,
      },
    }
  })
